import React from 'react'
import { StyleSheet, ViewPropTypes, View } from 'react-native'
import PropTypes from 'prop-types'
import { Button as PaperButton } from 'react-native-paper'
import { useTheme } from '../../theming/ThemeProvider'
import { usePlatforms } from '../../hooks/usePlatforms'
import Identity from '../../utils/Identity'

export default function Button ({ style, containerStyle, title, type, ...props }) {
  const { theme } = useTheme()
  const { isTablet } = usePlatforms()
  const styles = useStyles(theme, isTablet)

  return (
    <View style={containerStyle}>
      <PaperButton
        contentStyle={[
          styles.button,
          style,
          type === 'outlined' && styles.buttonOutlined,
          props.disabled && styles.disabled && styles.disabledButtonOutlined
        ]}
        labelStyle={[
          Identity.Font(isTablet).body2,
          styles.text,
          type === 'outlined' && styles.textOutlined,
          props.disabled && { color: theme.WHITE }
        ]}
        {...props}
      >
        {title}
      </PaperButton>
    </View>
  )
}

const useStyles = (theme, isTablet) => StyleSheet.create({
  button: {
    paddingHorizontal: 15,
    borderRadius: 5,
    width: isTablet ? 120 : '100%',
    height: 40,
    backgroundColor: theme.SECONDARY_BUNKER
  },
  buttonOutlined: {
    backgroundColor: theme.CARD_BACKGROUND,
    borderColor: theme.BUNKER,
    borderWidth: 1
  },
  disabledButtonOutlined: {
    backgroundColor: theme.SECOND_DISABLED_COLOR,
    borderColor: theme.SECOND_DISABLED_COLOR,
    borderWidth: 1
  },
  text: {
    textTransform: 'capitalize',
    fontSize: 13,
    color: theme.WHITE_TEXT,
    letterSpacing: 0
  },
  textOutlined: {
    color: theme.BUNKER
  },
  disabled: {
    backgroundColor: theme.SECOND_DISABLED_COLOR
  }
})

Button.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string.isRequired,
  onPress: PropTypes.func,
  style: ViewPropTypes.style,
  containerStyle: ViewPropTypes.style,
  loading: PropTypes.any,
  disabled: PropTypes.bool,
  testID: PropTypes.string
}

Button.defaultProps = {
  type: 'contained',
  title: '',
  style: null,
  containerStyle: null,
  loading: false,
  onPress: () => {},
  disabled: false,
  testID: null
}
